import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconCustomEazy = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Eazy'
  size = size ?? 16
  color = color ?? theme.colors.primary

  return (
    <Icon viewBox='0 0 150 150' ref={ref} title={title} size={size} color={color} overrides={overrides}>
      <title>{title}</title>
      <path d='M82.12,12.09c15.61,1.26,31.18,5.85,44.09,15.03,3.25,1.53,4.51,5.57,2.72,8.68-1.83,3.23-6.33,3.95-9.09,1.48-25.72-17.1-61.53-18.02-87.84-1.68-2.76,2.25-6.95,1.54-8.83-1.48-1.91-3.04-.7-7.15,2.54-8.69,16.67-10.8,36.74-14.82,56.41-13.33Z' />
      <path d='M70.53,70.09c-3.7,1.26-7.39,2.61-11.06,3.99-2.64,1.07-5.64-.17-6.77-2.78-1.4-2.75-.47-6.11,2.15-7.74,13.17-8.84,38.6-7.7,49.86,9.23-10,12.59-19.42,24.52-29.6,37.37,11.98,.61,23.76-.08,35.72,.3,10.55-.42,17.73,11.33,12.57,20.52-1.97,3.94-5.88,6.55-10.28,6.86-7.41,.6-56.39,.16-64.84,.28-3.75,.28-7.47-.8-10.48-3.05-6.2-4.93-6.98-14.15-1.72-20.07,11.63-14.77,23.28-29.5,34.98-44.19-.21-.21-.39-.46-.53-.72Z' />
      <path d='M74.67,34.44c13.81,.09,27.24,4.45,38.47,12.49,3.98,2.81,4.85,6.19,2.49,9.53-2.2,3.3-7.12,3.61-9.73,.63-16.71-12.79-39.48-14.26-57.7-3.73-3.91,2.31-7.16,1.92-9.11-1.14-2.03-3.18-.92-6.64,2.95-9.14,9.9-5.76,21.17-8.74,32.62-8.64Z' />
    </Icon>
  )
}

IconCustomEazy.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconCustomEazy
